import { DayPeriod } from '../enums/day-period.enum';
export function getElementById(id, parent = document) {
    return parent.querySelector(`#${id}`);
}
export function getStringValue(value) {
    return !value ? '00' : hourOrMinuteToString(value);
}
export function hourOrMinuteToString(value) {
    if (typeof value !== 'number') {
        return '';
    }
    return (value < 10 ? '0' : '') + value.toString();
}
export function isValidHour(hour) {
    return (typeof hour === 'undefined' ||
        (!isNaN(hour) && hour > -1 && hour < 24 && Math.floor(hour) === hour));
}
export function isValidMinute(minute) {
    return (typeof minute === 'undefined' ||
        (!isNaN(minute) &&
            minute > -1 &&
            minute < 60 &&
            Math.floor(minute) === minute));
}
export function parseHour(hour, ampm) {
    if (ampm) {
        if (ampm === DayPeriod.ANTE) {
            return hour === 12 ? 0 : hour;
        }
        return hour === 12 ? 12 : hour + 12;
    }
    return hour;
}
